import { createContext, useReducer } from 'react'
import { ContactInfo } from './Data'

export const Store = createContext()

const USER_KEY = 'UserInfo'
const TOKEN_KEY = 'slimfast_customer_token'

function readUser() {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

const initialState = {
  UserInfo: readUser(),
  Admin: localStorage.getItem('Admin')
    ? JSON.parse(localStorage.getItem('Admin'))
    : null,
  ContactInfo: localStorage.getItem('ContactInfo')
    ? JSON.parse(localStorage.getItem('ContactInfo'))
    : ContactInfo,
}

function reducer(state, action) {
  switch (action.type) {
    case 'UserLogin':
    case 'LawyerLogin':
    case 'UserLoggedIn': {
      const user = action.payload
      localStorage.setItem(USER_KEY, JSON.stringify(user))
      if (user?.token) localStorage.setItem(TOKEN_KEY, user.token)
      return { ...state, UserInfo: user }
    }
    case 'UserLogout':
    case 'LawyerLogout':
    case 'ClearUserInfo':
    case 'ResetUserInfo': {
      localStorage.removeItem(USER_KEY)
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem('Project')
      return { ...state, UserInfo: null, Project: null }
    }
    case 'Admin':
      return { ...state, Admin: action.payload }
    case 'update':
      return { ...state, UserInfo: action.payload }
    default:
      return state
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const value = { state, dispatch }
  return <Store.Provider value={value}>{props.children}</Store.Provider>
}
